import React from 'react';

export default function CardPadding({ children, style }) {
	return <div className="card-padding" style={style}>
		{children}
	</div>;
}